export const phonePrefixes = ['+387', '+381'];